import { PointsBankBalance, previewAwardType } from '@kudos/http-client'
import { useApiError } from '@shared/errors/useApiError'
import { getSendToFromTenantMemberAndTeams } from '@shared/utils/getSendToFromTenantMemberAndTeams'
import { useMutation } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { Control, FieldValues, Path, useWatch } from 'react-hook-form'
import { useDebounce } from 'use-debounce'

const useRecipientsPreview = <T extends FieldValues>(control: Control<T>, awardTypeId: string) => {
  const { handleApiError } = useApiError()
  const [recipientCount, setRecipientCount] = useState<number>(0)
  const [pointsRecipientCount, setPointsRecipientCount] = useState<number>(0)
  const [pointsBankBalance, setPointsBankBalance] = useState<PointsBankBalance | null>(null)
  const [totalSpend, setTotalSpend] = useState<number>(0)
  const amount = useWatch({ name: 'amount' as Path<T>, control })
  const sendTo = useWatch({ name: 'sendTo' as Path<T>, control })
  const [debouncedAmount] = useDebounce(amount, 250)

  const { mutateAsync: previewRecipients } = useMutation({
    mutationFn: previewAwardType,
    onSuccess: resp => {
      setRecipientCount(resp.recipientCount)
      setPointsRecipientCount(resp.pointsRecipientCount)
      setTotalSpend(resp.total)
      setPointsBankBalance(resp.pointsBankBalance || null)
    },
    onError: error => handleApiError(error),
  })

  useEffect(() => {
    if (sendTo.length > 0 && debouncedAmount > 0) {
      previewRecipients({
        amount: Number(debouncedAmount),
        sendTo: getSendToFromTenantMemberAndTeams(sendTo),
        awardTypeId,
      })
    }
  }, [sendTo.length, debouncedAmount])

  return { recipientCount, pointsRecipientCount, totalSpend, pointsBankBalance }
}

export default useRecipientsPreview
